module.exports = __webpack_public_path__ + "static/img/grave_hag.5fe647d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/grave_hag.png
// module id = Z6Mo
// module chunks = 0